export enum NotesFormLabelsEnum {
  ADD_NOTE = '+ Add Note',
  NOTES = 'Notes',
  AGE_ORDER = 'Order',
  NOTES_EMPTY = 'No Notes Found',
  NOTE_TYPE = 'Note Type',
}
